// extracted by mini-css-extract-plugin
export var dropdownButton = "_2v-0";
export var fullWidthDropdownButton = "_2v-1";
export var icon = "_2v-3";
export var iconPlaceholder = "_2v-2";
export var menuItemRow = "_2v-9";
export var separator = "_2v-e";
export var shortcutContainer = "_2v-7";
export var shortcutContainerFilled = "_2v-8";
export var shortcutIconLg = "_2v-6";
export var shortcutIconMd = "_2v-5";
export var shortcutIconSm = "_2v-4";
export var submenuChevron = "_2v-d";
export var submenuDropdown = "_2v-a";
export var submenuTriggerRow = "_2v-b";
export var submenuTriggerRowOpen = "_2v-c";